import type { InputHTMLAttributes } from 'react'

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: string
  autoWidth?: boolean
}

export function Input({ className = '', error, autoWidth = false, style, ...props }: InputProps) {
  const mergedStyle = {
    ...(autoWidth ? { fieldSizing: 'content' as any, minWidth: '4rem' } : {}),
    ...style,
  }

  return (
    <div className={autoWidth ? 'inline-block' : 'w-full'}>
      <input
        className={`h-9 rounded-[var(--radius-sm)] border bg-white px-3 text-sm text-[var(--color-text)] placeholder:text-slate-400 outline-none focus:border-[var(--color-accent)] focus:ring-1 focus:ring-[var(--color-accent)]/30 ${
          autoWidth ? 'w-auto' : 'w-full'
        } ${error ? 'border-red-400' : 'border-[var(--color-border)]'} ${className}`}
        style={mergedStyle}
        {...props}
      />
      {error ? <p className="mt-1 text-xs text-red-600">{error}</p> : null}
    </div>
  )
}
